import React from "react";
import { Field, FieldArrayRenderProps } from "@progress/kendo-react-form";
import { Card, GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Button } from "@progress/kendo-react-buttons";
import { Typography } from "@progress/kendo-react-common";
import IconButton from "../../../components/common/IconButton";
import { MdDelete } from "react-icons/md";
import FormTextField from "../../../components/formFields/FormTextField";
import FormNumericTextField from "../../../components/formFields/FormNumericTextField";
import FormRichTextField from "../../../components/formFields/FormRichTextField";
import { requiredValidator } from "../../../components/formFields/CommonValidator";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { openDialog, closeDialog } from "../../../components/dialog/dialogSlice";
import AppDialog, { DialogCloseButton } from "../../../components/dialog/Dialog";
import FormSelectionField from "../../../components/formFields/FormSelectionField";

const DURATION_TYPES = [
  { label: "Mins", value: "Mins" },
  { label: "Hrs", value: "Hrs" },
  { label: "Days", value: "Days" },
];

const ActivityDetailsArray = (fieldArrayRenderProps: FieldArrayRenderProps) => {
  const dispatch = useAppDispatch();
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const [deleteIndex, setDeleteIndex] = React.useState<number>(-1);

  const handleOpenDeleteDialog = (index: number) => {
    setDeleteIndex(index);
    dispatch(openDialog("activityDetailDeleteDialog"));
  };

  const handleDeleteAction = () => {
    fieldArrayRenderProps.onRemove({ index: deleteIndex });
    dispatch(closeDialog());
    setDeleteIndex(-1);
  };

  const addActivity = () => {
    fieldArrayRenderProps.onPush({
      value: {
        Name: "",
        Slots: "",
        Duration: 0,
        DurationType: "",
        ItineraryDetails: "",
      },
    });
  };

  return (
    <GridLayout cols={[{ width: "100%" }]}>
      <GridLayoutItem style={{ marginBottom: 10, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Typography.h5 className="m-0">Detailed Activity Items</Typography.h5>
        <Button
          fillMode={"solid"}
          themeColor={"primary"}
          onClick={addActivity}
          type="button"
        >
          Add Activity Detail
        </Button>
      </GridLayoutItem>

      {dialogName === "activityDetailDeleteDialog" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Activity Detail"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>Are you sure you want to delete this activity detail?</Typography.p>
              </GridLayoutItem>
              <GridLayoutItem style={{ display: "flex", justifyContent: "end" }}>
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={handleDeleteAction}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}

      {fieldArrayRenderProps.value &&
        fieldArrayRenderProps.value.map((_: any, index: number) => (
          <GridLayoutItem key={index}>
            <Card className="fieldarray-card" style={{ padding: 15, marginBottom: 10 }}>
              <GridLayout
                gap={{ rows: 10, cols: 10 }}
                style={{ marginRight: 20 }}
                cols={[{ width: "33%" }, { width: "33%" }, { width: "34%" }]}
              >
                <GridLayoutItem colSpan={2} className="d-flex gap-2">
                  <Field
                    name={`ActivityDetails.${index}.Name`}
                    wrapperClassName="m-0 w-100"
                    label="Activity Name"
                    placeholder="e.g. Houseboat Cruise"
                    component={FormTextField}
                    validator={requiredValidator}
                    astrike={true}
                  />
                </GridLayoutItem>

                <GridLayoutItem style={{ display: "flex", justifyContent: "end", alignItems: "start" }}>
                  <IconButton
                    onClick={() => handleOpenDeleteDialog(index)}
                    disabled={fieldArrayRenderProps.value.length === 1}
                    themeColor={"error"}
                    size={"small"}
                    fillMode={"solid"}
                    type="button"
                    style={{ width: "32px", height: "32px", marginTop: "20px" }}
                    icon={MdDelete}
                    iconClassName="absolute-position"
                    iconStyle={{ fontSize: "24px" }}
                  />
                </GridLayoutItem>

                <GridLayoutItem>
                  <Field
                    name={`ActivityDetails.${index}.Slots`}
                    label="Slots"
                    placeholder="e.g. 11:00, 12:00, 03:00"
                    component={FormTextField}
                  // validator={requiredValidator}
                  // astrike={true}
                  />
                </GridLayoutItem>

                <GridLayoutItem>
                  <Field
                    name={`ActivityDetails.${index}.Duration`}
                    label="Duration"
                    component={FormNumericTextField}
                  // validator={requiredValidator}
                  // astrike={true}
                  />
                </GridLayoutItem>

                <GridLayoutItem>
                  <Field
                    name={`ActivityDetails.${index}.DurationType`}
                    label="Duration Type"
                    component={FormSelectionField}
                    // validator={requiredValidator}
                    // astrike={true}
                    options={DURATION_TYPES}
                  />
                </GridLayoutItem>

                <GridLayoutItem colSpan={3}>
                  <Field
                    name={`ActivityDetails.${index}.ItineraryDetails`}
                    wrapperStyle={{ margin: 0 }}
                    label="Itinerary Details"
                    component={FormRichTextField}
                    minHeight={100}
                  />
                </GridLayoutItem>

              </GridLayout>
            </Card>
          </GridLayoutItem>
        ))}
    </GridLayout>
  );
};

export default ActivityDetailsArray;
